import { FC, ReactNode } from 'react';

import { CloseIcon, CollapseIcon } from 'assets/icons';
import { If } from 'components/Generics';
import { customTwMerge as twMerge, translate } from 'utils';

type ModalHeaderProp = {
  title: ReactNode | string;
  onClose: () => void;
  titleClassName?: string;
  showCloseIcon?: boolean;
  closeDisabled?: boolean;
  /** When provided, a minimize button is shown next to the close icon. */
  onMinimize?: () => void;
};

const ModalHeader: FC<ModalHeaderProp> = ({
  title,
  onClose,
  titleClassName,
  showCloseIcon = true,
  closeDisabled = false,
  onMinimize
}) => {
  const closeButton = (
    <If condition={showCloseIcon}>
      <button
        data-testid='close'
        type='button'
        onClick={onClose}
        disabled={closeDisabled}
        className={closeDisabled ? 'opacity-50 cursor-not-allowed' : undefined}
      >
        <CloseIcon className='h-3 w-3 ' />
      </button>
    </If>
  );

  return (
    <div className='flex justify-between items-center mb-6'>
      <h2
        className={twMerge(
          'text-xl text-DEFAULT_TEXT md:leading-6 leading-8 md:font-bold font-normal',
          titleClassName
        )}
      >
        {title}
      </h2>
      {onMinimize ? (
        <div className='flex items-center gap-4'>
          <button
            data-testid='minimize'
            type='button'
            onClick={onMinimize}
            aria-label={translate('common.minimize')}
            title={translate('common.minimize')}
          >
            <CollapseIcon className='h-3.5 w-3.5 text-DEFAULT_TEXT' />
          </button>
          {closeButton}
        </div>
      ) : (
        closeButton
      )}
    </div>
  );
};

export default ModalHeader;
